import React from 'react';
import {Image} from 'react-bootstrap';
import './Application.css';
import {connect} from 'react-redux';
import agent from '../agent';
import groups from '../data/groups.json';
import {modal} from 'react-redux-modal';
import PDF from 'react-pdf-js';
import ReactDOM from 'react-dom';



const mapSateToProps = state => ({ ...state.application,
properties: state.home.properties,
});

const mapDispatchToProps = dispatch => ({
	onLoad: payload =>
	    dispatch({ type: 'PAGE_LOADED', payload}),
	onChangeGroup: value =>
	    dispatch({ type: 'UPDATE_APP_FIELD', key: 'group', value }),
	onChangeVehicleNumber: value =>
	    dispatch({ type: 'UPDATE_APP_FIELD', key: 'vehicleNumber', value }),
	onChangeLicense: value =>
	    dispatch({ type: 'UPDATE_APP_FIELD', key: 'license', value }),
	onChangeIncome: value =>
	    dispatch({ type: 'UPDATE_APP_FIELD', key: 'income', value }),
	onAddIncome: value =>
	    dispatch({ type: 'UPDATE_APP_INCOME', key: 'income', value }),
	onDeleteFile : value =>
		dispatch({ type:'DELETE_APP_INCOME', key: 'income', value}),
	onChangeRulesAgreement: (value) =>
	    dispatch({ type: 'UPDATE_APP_FIELD', key: 'ruleAgreement', value}),
	onChangeField: (k, value) =>
		dispatch({ type: 'UPDATE_APP_FIELD', key: k, value }),
	handleRuleCLick: () => dispatch({type: 'UPDATE_APP_FIELD', key: 'ruleCLick', value: true})
});

class Application extends React.Component{
	constructor(){
		super();
		this.changeGroup = ev => this.props.onChangeGroup(ev.target.value);
		this.changeVehicleNumber = ev => this.props.onChangeVehicleNumber(ev.target.value);
		this.changeRulesAgreement = ev => {
			this.props.onChangeRulesAgreement(ev.target.value);
		}
		this.changeAIFN = ev => {this.props.onChangeField('firstName', ev.target.value); console.log(ev.target)};
		this.changeAIMN = ev =>this.props.onChangeField("midddleName", ev.target.value);
		this.changeAILN = ev =>this.props.onChangeField("lastName", ev.target.value);
		this.changeValue = ev => this.props.onChangeField(ev.target.id, ev.target.value);
		this.handleRuleCLick = ev => {this.props.handleRuleCLick();}
		this.submitForm = (data, files) => ev => {
			ev.preventDefault();
			var destination = Math.random().toString(36).substring(2);	

			agent.Application.submit(data, files);

			console.log("form submitted");
			// window.location.reload();
		};
	}

	componentWillMount() {
	    this.props.onLoad(agent.Groups.all());
	  }

	_handleIDChange(e) {
		e.preventDefault();
		var reader = new FileReader();
		var file = e.target.files[0];

		
		reader.onloadend = () => {
			if (!this.props.license) {
				this.props.onChangeLicense(file);
			}
		}
		reader.readAsDataURL(file)
	}

	_handleIncomeChange(e) {
		e.preventDefault();
		var reader = new FileReader();
		var file = e.target.files[0];

		
		reader.onloadend = () => {
			if (!this.props.income) {
				this.props.onChangeIncome(file);
			}
			else{
				this.props.onAddIncome(file);
			}
		}

		reader.readAsDataURL(file)

	}


	handleRadioClick(e) {
		e.preventDefault();
		if(!this.props.ruleCLick){
			console.alert("You must Click and read the Rules and Regulations");
		}
		else{
			this.props.changeRulesAgreement();
		}
	}



	render(){
		const properties = this.props.properties;
		const license = this.props.license;
		const income = this.props.income;
		const vehicleNumber = this.props.vehicleNumber;
		const ruleAgreement = this.props.ruleAgreement;

		var vehicleList = null;
		var vehicles = this.props.vehicles;

		var group = this.props.group;


		var address;

		var propertyInformation = {
			unitNumber : this.props.unitNumber,
			unitMonthlyPay : this.props.unitMonthlyPay,
		}

		var applicantInfo = {
			firstName: this.props.firstName,
			midddleName: this.props.midddleName,
			lastName: this.props.lastName,
			DOB: this.props.DOB,
			email: this.props.email,
			workPhone: this.props.workPhone,
			homePhone: this.props.homePhone,
			cellPhone: this.props.cellPhone,
			driversLicense: this.props.driversLicense,
			credit: this.props.credit
		}

		var additionalOccupants = {
			nameOne: this.props.nameOne,
			dobOne: this.props.dobOne,
			relationship2ApplicantOne: this.props.relationship2ApplicantOne,
			nameTwo: this.props.nameTwo,
			dobTwo: this.props.dobTwo,
			relationship2ApplicantTwo: this.props.relationship2ApplicantTwo,
			nameThree: this.props.nameThree,
			dobThree: this.props.dobThree,
			relationship2ApplicantThree: this.props.relationship2ApplicantThree,
			nameFour: this.props.nameFour,
			dobFour: this.props.dobFour,
			relationship2ApplicantFour: this.props.relationship2ApplicantFour,
			nameFive: this.props.nameFive,
			dobFive: this.props.dobFive,
			relationship2ApplicantFive: this.props.relationship2ApplicantFive
		}

		var car = {

		}

		var	currentResidence = {
				addressC: this.props.CRaddress,
				cityC: this.props.CRcity,
				stateC: this.props.CRstate,
				zipCodeC: this.props.CRzipCode,
				monthlyRentC: this.props.CRmonthlyRent,
				datesResidencyC: this.props.CRdatesResidency,
				reasonForMovingC: this.props.CRreasonForMoving,
				ownerNameC: this.props.CRownerName,
				ownerPhoneC: this.props.CRownerPhone
			}

		var	previousResidence = {
				addressP: this.props.PRaddress,
				cityP: this.props.PRcity,
				stateP: this.props.PRstate,
				zipCodeP: this.props.PRzipCode,
				monthlyRentP: this.props.PRmonthlyRent,
				datesResidencyP: this.props.PRdatesResidency,
				reasonForMovingP: this.props.PRreasonForMoving,
				ownerNameP: this.props.PRownerName,
				ownerPhoneP: this.props.PRownerPhone
		}

		var employmentHistory = {
			currentEmployer : this.props.currentEmployer,
			occupation: this.props.occupation,
			employerAddress: this.props.employerAddress,
			employerPhone: this.props.employerPhone,
			datesEmployment: this.props.datesEmployment,
			supervisorName: this.props.supervisorName,
			monthlyPay: this.props.monthlyPay,
			additionalPay: this.props.additionalPay
		}

		var personalReferences = {
			name1: this.props.name1,
			relationship1: this.props.relationship1,
			phone1: this.props.phone1,
			name2: this.props.name2,
			relationship2: this.props.relationship2,
			phone2: this.props.phone2,
		}

		var questions = {
			q1: this.props.q1,
			q2: this.props.q2,
			q3: this.props.q3,
			q4: this.props.q4,
			q5: this.props.q5,
			q6: this.props.q6,
			q7: this.props.q7,
			additional: this.props.additional
		}

		var vehicles = {
			model1: this.props.model1,
			make1: this.props.make1,
			color1: this.props.color1,
			year1: this.props.year1,
			license1: this.props.license1,
			insurance1: this.props.insurance1,
			model2: this.props.model2,
			make2: this.props.make2,
			color2: this.props.color2,
			year2: this.props.year2,
			license2: this.props.license2,
			insurance2: this.props.insurance2,
		}

		var signature = {signature: this.props.signature}

		var data = {
				applicantInfo, 
				additionalOccupants,  
				employmentHistory, 
				questions, 
				personalReferences,
				propertyInformation,
				vehicles,
				signature,
				currentResidence,
				previousResidence
			 };

		var files = {
			license, 
			income
		}
		//this.props.applicantInfo;

		if (!this.props.properties) {
			return (
				<div>
					Loading...
				</div>

			);
		}
		if (group){
			if (group[0] == "--") {
				address = "";
				group = undefined;
			}
			else{
				var groupNum;
				console.log(group);
				for (var i = 0; i < groups.length; i++)  {
					if(groups[i]._id == group[0]){
						groupNum = i;
					}
				};
				address = groups[groupNum].address;
				propertyInformation.addressPI = address;
				var rules = groups[groupNum].rules;
			}
		}
		const groupList = properties.map((group) =>
			<option key={group._id} value={group._id}>{group.name}</option>
		);


		return(
			<div className="container page">
				<div className="row center-block">
					<h1>Property Application</h1>
				</div>
				<form onSubmit={this.submitForm(data, files)}>
					<h3>Property Information</h3>
					<div className="row">
						<div className="col-md-2">
							<fieldset className="form-group">
			                  	<label> Select property</label>
			                  	<select name="groups" 
			                  	  className="form-control form-control-lg"
			                  	  value={group}
			                  	  required
			                  	  onChange={this.changeGroup}>
			                  	    <option>--</option>
			                  		{groupList}
			                  	</select>
			                  </fieldset>
						</div>
					</div>

					{ group &&
					<div>
						<div className="row">
							<div className="col-md-3">
								<fieldset className="form-group">
				                  	<label>Address</label>
				                  	<p>
				                  	    {address}
				                  	</p>
				                  </fieldset>
							</div>
							<div className="col-md-2">
			                  	<fieldset className="form-group">
									<label>Unit Number</label>
										<input
											className="form-control form-control-lg"
											type="text"
											placeholder="203"
											value={propertyInformation.unitNumber}
											onChange={this.changeValue}
											id="unitNumber"/>
								</fieldset>
							</div>
							<div className="col-md-2">
			                  	<fieldset className="form-group">
									<label>Monthly Rent</label>
										<input
											className="form-control form-control-lg"
											type="text"
											placeholder=""
											value={propertyInformation.unitMonthlyPay}
											onChange={this.changeValue}
											id="unitMonthlyPay"/>
								</fieldset>
							</div>
						</div>

					
						<h3>Applicant Information</h3>
					
					<div className="row">
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>First Name</label>
								<input
									className="form-control form-control-lg"
									type="text"
									required
									placeholder="First Name"
									value={applicantInfo.firstName}
									onChange={this.changeValue}
									id="firstName"/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>Middle Name</label>
								<input
									className="form-control form-control-lg"
									id="midddleName"
									type="text"
									placeholder="Middle Name"
									value={applicantInfo.midddleName}
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>Last Name</label>
								<input
									className="form-control form-control-lg"
									id="lastName"
									required
									type="text"
									placeholder="Last Name"
									value={applicantInfo.lastName}
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>DOB</label>
								<input
									required
									className="form-control form-control-lg"
									type="text"
									placeholder="##/##/##"
									value={applicantInfo.DOB}
									id="DOB"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>Email Address</label>
								<input
									required
									className="form-control form-control-lg"
									type="email"
									placeholder="Email"
									value={applicantInfo.email}
									id="email"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>Home Phone</label>
								<input
									className="form-control form-control-lg"
									type="tel"
									placeholder="999-999-9999"
									value={applicantInfo.homePhone}
									id="homePhone"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>Cell Phone</label>
								<input
									className="form-control form-control-lg"
									type="tel"
									placeholder="999-999-9999"
									value={applicantInfo.cellPhone}
									id="cellPhone"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>Work Phone</label>
								<input
									className="form-control form-control-lg"
									type="tel"
									placeholder="999-999-9999"
									value={applicantInfo.workPhone}
									id="workPhone"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
					</div>

					<div className="row">
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>Drivers License #</label>
								<input
									required
									className="form-control form-control-lg"
									type="text"
									placeholder="Driver's License #"
									value={applicantInfo.driversLicense}
									id="driversLicense"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>Upload Copy of License</label>
								<input
								  required
			                      className="form-control form-control-lg"
			                      type="file"
			                      placeholder="Upload Copy of License"
			                      onChange={(e)=>this._handleIDChange(e)}/>
		                	</fieldset>
		                </div>
					</div>
					<div className="row">
						<div className="col-md-2">
							<fieldset className="form-group">
			                  	<label>Credit Score</label>
			                  	<select name="groups" 
			                  	  required
			                  	  className="form-control form-control-lg"
			                  	  value={applicantInfo.credit}
			                  	  onChange={this.changeValue}
			                  	  id="credit">
			                  	    <option>--</option>
			                  		<option value="< 500">{"<"} 500</option>
			                  		<option value="500 - 600">500 - 600</option>
			                  		<option value="> 600">{">"} 600</option>
			                  	</select>
			                  </fieldset>
						</div>
					</div>
					<h4>Additional Occupants</h4>
					<div className="row">
						<div className="col-md-6">
							<fieldset className="form-group">
							<label>First, Middle, Last Name</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder="First, Middle, Last Name"
									value={additionalOccupants.nameOne}
									id="nameOne"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-2">
							<fieldset className="form-group">
							<label>DOB</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder="##/##/##"
									value={additionalOccupants.dobOne}
									id="dobOne"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>Relationship to Applicant</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder=""
									value={additionalOccupants.relationship2ApplicantOne}
									id="relationship2ApplicantOne"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-6">
							<fieldset className="form-group">
							<label>First, Middle, Last Name</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder="First, Middle, Last Name"
									value={additionalOccupants.nameTwo}
									id="nameTwo"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-2">
							<fieldset className="form-group">
							<label>DOB</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder="##/##/##"
									value={additionalOccupants.dobTwo}
									id="dobTwo"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>Relationship to Applicant</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder=""
									value={additionalOccupants.relationship2ApplicantTwo}
									id="relationship2ApplicantTwo"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-6">
							<fieldset className="form-group">
							<label>First, Middle, Last Name</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder="First, Middle, Last Name"
									value={additionalOccupants.nameThree}
									id="nameThree"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-2">
							<fieldset className="form-group">
							<label>DOB</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder="##/##/##"
									value={additionalOccupants.dobThree}
									id="dobThree"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>Relationship to Applicant</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder=""
									value={additionalOccupants.relationship2ApplicantThree}
									id="relationship2ApplicantThree"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-6">
							<fieldset className="form-group">
							<label>First, Middle, Last Name</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder="First, Middle, Last Name"
									value={additionalOccupants.nameFour}
									id="nameFour"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-2">
							<fieldset className="form-group">
							<label>DOB</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder="##/##/##"
									value={additionalOccupants.dobFour}
									id="dobFour"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>Relationship to Applicant</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder=""
									value={additionalOccupants.relationship2ApplicantFour}
									id="relationship2ApplicantFour"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-6">
							<fieldset className="form-group">
							<label>First, Middle, Last Name</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder="First, Middle, Last Name"
									value={additionalOccupants.nameFive}
									id="nameFive"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-2">
							<fieldset className="form-group">
							<label>DOB</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder="##/##/##"
									value={additionalOccupants.dobFive}
									id="dobFive"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>Relationship to Applicant</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder=""
									value={additionalOccupants.relationship2ApplicantFive}
									id="relationship2ApplicantFive"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
					</div>
						<h3>Rental History</h3>
					<h4>Current Residence</h4>
					<div className="row">
						<div className="col-md-4">
							<fieldset className="form-group">
							<label>Address</label>
								<input
									required
									className="form-control form-control-lg"
									type="text"
									placeholder="1234 NW 8th St"
									value={currentResidence.CRaddress}
									id="CRaddress"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>City</label>
								<input
									required
									className="form-control form-control-lg"
									type="text"
									placeholder="City"
									value={currentResidence.CRcity}
									id="CRcity"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-2">
							<fieldset className="form-group">
							<label>State</label>
								<input
									required
									className="form-control form-control-lg"
									type="text"
									placeholder="FL"
									value={currentResidence.CRstate}
									id="CRstate"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-2">
							<fieldset className="form-group">
							<label>Zip Code</label>
								<input
									required
									className="form-control form-control-lg"
									type="text"
									placeholder="#####"
									value={currentResidence.CRzipCode}
									id="CRzipCode"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-2">
							<fieldset className="form-group">
							<label>Monthly Rent</label>
								<input
									required
									className="form-control form-control-lg"
									type="currency"
									placeholder="$"
									value={currentResidence.CRmonthlyRent}
									id="CRmonthlyRent"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>Dates of Residency (From/To)</label>
								<input
									required
									className="form-control form-control-lg"
									type="text"
									placeholder="mm/dd/yy - mm/dd/yy"
									value={currentResidence.CRdatesResidency}
									id="CRdatesResidency"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-5">
							<fieldset className="form-group">
							<label>Reason for Moving</label>
								<input
									required
									className="form-control form-control-lg"
									type="text"
									placeholder=""
									value={currentResidence.CRreasonForMoving}
									id="CRreasonForMoving"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>Owner/Manager's Name</label>
								<input
									required
									className="form-control form-control-lg"
									type="text"
									placeholder="Jane Smith"
									value={currentResidence.CRownerName}
									id="CRownerName"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-4">
							<fieldset className="form-group">
							<label>Owner/Manarger's Phone Number</label>
								<input
									required
									className="form-control form-control-lg"
									type="tel"
									placeholder="999-999-9999"
									value={currentResidence.CRownerPhone}
									id="CRownerPhone"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
					</div>
					<h4>Previous Residence</h4>
					<div className="row">
						<div className="col-md-4">
							<fieldset className="form-group">
							<label>Address</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder="1234 NW 8th St"
									value={previousResidence.PRaddress}
									id="PRaddress"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>City</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder="City"
									value={previousResidence.PRcity}
									id="PRcity"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-2">
							<fieldset className="form-group">
							<label>State</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder="FL"
									value={previousResidence.PRstate}
									id="PRstate"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-2">
							<fieldset className="form-group">
							<label>Zip Code</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder="#####"
									value={previousResidence.PRzipCode}
									id="PRzipCode"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-2">
							<fieldset className="form-group">
							<label>Monthly Rent</label>
								<input
									className="form-control form-control-lg"
									type="currency"
									placeholder="$"
									value={previousResidence.PRmonthlyRent}
									id="PRmonthlyRent"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>Dates of Residency (From/To)</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder="mm/dd/yy - mm/dd/yy"
									value={previousResidence.PRdatesResidency}
									id="PRdatesResidency"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-5">
							<fieldset className="form-group">
							<label>Reason for Moving</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder=""
									value={previousResidence.PRreasonForMoving}
									id="PRreasonForMoving"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>Owner/Manager's Name</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder="Jane Smith"
									value={previousResidence.PRownerName}
									id="PRownerName"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-4">
							<fieldset className="form-group">
							<label>Owner/Manarger's Phone Number</label>
								<input
									className="form-control form-control-lg"
									type="tel"
									placeholder="999-999-9999"
									value={previousResidence.PRownerPhone}
									id="PRownerPhone"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
					</div>

						<h3>Employment History</h3>
					<div className="row">
						<div className="col-md-4">
							<fieldset className="form-group">
							<label>Current Employer</label>
								<input
									required
									className="form-control form-control-lg"
									type="text"
									placeholder=""
									value={employmentHistory.currentEmployer}
									id="currentEmployer"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>Occupation</label>
								<input
									required
									className="form-control form-control-lg"
									type="text"
									placeholder=""
									value={employmentHistory.occupation}
									id="occupation"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-6">
							<fieldset className="form-group">
							<label>Employer Address</label>
								<input
									required
									className="form-control form-control-lg"
									type="text"
									placeholder="1234 NW 8th St Miami, FL 33315"
									value={employmentHistory.employerAddress}
									id="employerAddress"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>Employer Phone</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder=""
									value={employmentHistory.employerPhone}
									id="employerPhone"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
							<label>Date of Employment (From/To)</label>
								<input
									required
									className="form-control form-control-lg"
									type="text"
									placeholder="mm/dd/yy - mm/dd/yy"
									value={employmentHistory.datesEmployment}
									id="datesEmployment"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-4">
							<fieldset className="form-group">
							<label>Supervisors Name</label>
								<input
									required
									className="form-control form-control-lg"
									type="text"
									placeholder=""
									value={employmentHistory.supervisorName}
									id="supervisorName"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-2">
							<fieldset className="form-group">
							<label>Monthly Pay</label>
								<input
									required
									className="form-control form-control-lg"
									type="text"
									placeholder=""
									value={employmentHistory.monthlyPay}
									id="monthlyPay"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-4">
							<fieldset className="form-group">
								<label>Additional Monthly Pay <br/> (ie. child support, second job, extra income)</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder="$"
									value={employmentHistory.additionalPay}
									id="currentEmployer"
									onChange={this.additionalPay}/>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-4">
							<fieldset className="form-group">
								<label>Submit proof on income <br/> (ie. bank statement, pay stub, offer letter)</label>
								<input
								  required
			                      className="form-control form-control-lg"
			                      type="file"
			                      placeholder="Upload Proof of Income"
			                      onChange={(e)=>this._handleIncomeChange(e)}/>
							</fieldset>
						</div>
					</div>

						<h3>Personal References</h3>
					<div className="row">
						<div className="col-md-3">
							<fieldset className="form-group">
								<label>Full Name</label>
								<input
									required
									className="form-control form-control-lg"
									type="text"
									placeholder="Jane Smith"
									value={personalReferences.name1}
									id="name1"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
								<label>Relationship to Applicant</label>
								<input
									required
									className="form-control form-control-lg"
									type="text"
									placeholder="Supervisor"
									value={personalReferences.relationship1}
									id="relationship1"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
								<label>Phone Number</label>
								<input
									required
									className="form-control form-control-lg"
									type="text"
									placeholder="(###)-###-####"
									value={personalReferences.phone1}
									id="phone1"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-3">
							<fieldset className="form-group">
								<label>Full Name</label>
								<input
									required
									className="form-control form-control-lg"
									type="text"
									placeholder="Jane Smith"
									value={personalReferences.name2}
									id="name2"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
								<label>Relationship to Applicant</label>
								<input
									required
									className="form-control form-control-lg"
									type="text"
									placeholder="Supervisor"
									value={personalReferences.relationship2}
									id="relationship2"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-3">
							<fieldset className="form-group">
								<label>Phone Number</label>
								<input
									required
									className="form-control form-control-lg"
									type="text"
									placeholder="(###)-###-####"
									value={personalReferences.phone2}
									id="phone2"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
					</div>

						<h3>Vehicles</h3>
					<div className="row">
						<div className="col-md-2">
							<fieldset className="form-group">
								<label>Number of Vehicles</label>
								<input
									className="form-control form-control-lg"
									type="number"
									placeholder="Max 2"/>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-2">
							<fieldset className="form-group">
								<label>Make</label>
									<input
										className="form-control form-control-lg"
										type="text"
										placeholder=""
										value={vehicles.make1}
										id="make1"
										onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-2">
							<fieldset className="form-group">
								<label>Model</label>
									<input
										className="form-control form-control-lg"
										type="text"
										placeholder=""
										value={vehicles.model1}
										id="model1"
										onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-2">
							<fieldset className="form-group">
								<label>Color</label>
									<input
										className="form-control form-control-lg"
										type="text"
										placeholder=""
										value={vehicles.color1}
										id="color1"
										onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-2">
							<fieldset className="form-group">
								<label>Year</label>
									<input
										className="form-control form-control-lg"
										type="text"
										placeholder=""
										value={vehicles.year1}
										id="year1"
										onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-2">
							<fieldset className="form-group">
								<label>License No.</label>
									<input
										className="form-control form-control-lg"
										type="text"
										placeholder=""
										value={vehicles.license1}
										id="license1"
										onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-2">
							<fieldset className="form-group">
								<label>Insurance Policy #</label>
									<input
										className="form-control form-control-lg"
										type="text"
										placeholder=""
										value={vehicles.insurance1}
										id="insurance1"
										onChange={this.changeValue}/>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-2">
							<fieldset className="form-group">
								<label>Make</label>
									<input
										className="form-control form-control-lg"
										type="text"
										placeholder=""
										value={vehicles.make2}
										id="make2"
										onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-2">
							<fieldset className="form-group">
								<label>Model</label>
									<input
										className="form-control form-control-lg"
										type="text"
										placeholder=""
										value={vehicles.model2}
										id="model2"
										onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-2">
							<fieldset className="form-group">
								<label>Color</label>
									<input
										className="form-control form-control-lg"
										type="text"
										placeholder=""
										value={vehicles.color2}
										id="color2"
										onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-2">
							<fieldset className="form-group">
								<label>Year</label>
									<input
										className="form-control form-control-lg"
										type="text"
										placeholder=""
										value={vehicles.year2}
										id="year2"
										onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-2">
							<fieldset className="form-group">
								<label>License No.</label>
									<input
										className="form-control form-control-lg"
										type="text"
										placeholder=""
										value={vehicles.license2}
										id="license2"
										onChange={this.changeValue}/>
							</fieldset>
						</div>
						<div className="col-md-2">
							<fieldset className="form-group">
								<label>Insurance Policy #</label>
									<input
										className="form-control form-control-lg"
										type="text"
										placeholder=""
										value={vehicles.insurance2}
										id="insurance2"
										onChange={this.changeValue}/>
							</fieldset>
						</div>
					</div>
						<h3>General Information</h3>
					<div className="row">
						<div className="col-md-12">
							<fieldset className="form-group">
							<div className="row">
								<div className="col-md-12">
									<label>Do you smoke?</label>
								</div>
							</div>
							<div className="row">
								<div className="col-md-1">
									<input type="radio" value="yes" 
									id="q1"
									checked={this.props.q1 == "yes"}
									onChange={this.changeValue}/> Yes
								</div>
								<div className="col-md-1">
								    <input type="radio" value="no" 
									id="q1"
									checked={this.props.q1 == "no"}
									onChange={this.changeValue}/> No
								</div>
							</div>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							<fieldset className="form-group">
							<div className="row">
								<div className="col-md-12">
									<label>Do you have any pets?</label>
								</div>
							</div>
							<div className="row">
								<div className="col-md-1">
									<input type="radio" value="yes"
									id="q2"
									checked={this.props.q2 == "yes"}
									onChange={this.changeValue}/> Yes
								</div>
								<div className="col-md-1">
								    <input type="radio" value="no"
									id="q2"
									checked={this.props.q2 == "no"}
									onChange={this.changeValue}/> No
								</div>
							</div>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							<fieldset className="form-group">
							<div className="row">
								<div className="col-md-12">
									<label>Have you ever filed for bankruptcy</label>
								</div>
							</div>
							<div className="row">
								<div className="col-md-1">
									<input type="radio" value="yes"
									id="q3"
									checked={this.props.q3 == "yes"}
									onChange={this.changeValue}/> Yes
								</div>
								<div className="col-md-1">
								    <input type="radio" value="no"
									id="q3"
									checked={this.props.q3 == "no"}
									onChange={this.changeValue}/> No
								</div>
							</div>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							<fieldset className="form-group">
							<div className="row">
								<div className="col-md-12">
									<label>Do you have any musical instruments?</label>
								</div>
							</div>
							<div className="row">
								<div className="col-md-1">
									<input type="radio" value="yes"
									id="q4"
									checked={this.props.q4 == "yes"}
									onChange={this.changeValue}/> Yes
								</div>
								<div className="col-md-1">
								    <input type="radio" value="no"
									id="q4"
									checked={this.props.q4 == "no"}
									onChange={this.changeValue}/> No
								</div>
							</div>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							<fieldset className="form-group">
							<div className="row">
								<div className="col-md-12">
									<label>Do you have any water filled furniture or do you intend to use water filled furniture in the apartment?</label>
								</div>
							</div>
							<div className="row">
								<div className="col-md-1">
									<input type="radio" value="yes"
									id="q5"
									checked={this.props.q5 == "yes"}
									onChange={this.changeValue}/> Yes
								</div>
								<div className="col-md-1">
								    <input type="radio" value="no"
									id="q5"
									checked={this.props.q5 == "no"}
									onChange={this.changeValue}/> No
								</div>
							</div>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							<fieldset className="form-group">
							<div className="row">
								<div className="col-md-12">
									<label>Have you ever been convicted for selling, possessing, distributing, or manufacturing illegal drugs or convicted of any other crime?</label>
								</div>
							</div>
							<div className="row">
								<div className="col-md-1">
									<input type="radio" value="yes"
									id="q6"
									checked={this.props.q6 == "yes"}
									onChange={this.changeValue}/> Yes
								</div>
								<div className="col-md-1">
								    <input type="radio" value="no"
									id="q6"
									checked={this.props.q6 == "no"}
									onChange={this.changeValue}/> No
								</div>
							</div>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							<fieldset className="form-group">
							<div className="row">
								<div className="col-md-12">
									<label>Have you ever been evicted for non-payment of rent or any other reason?</label>
								</div>
							</div>
							<div className="row">
								<div className="col-md-1">
									<input type="radio" value="yes"
									id="q7"
									checked={this.props.q7 == "yes"}
									onChange={this.changeValue}/> Yes
								</div>
								<div className="col-md-1">
								    <input type="radio" value="no"
									id="q7"
									checked={this.props.q7 == "no"}
									onChange={this.changeValue}/> No
								</div>
							</div>
							</fieldset>
						</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							<fieldset className="form-group">
								<label>Please explain any "yes" answers to the above questions:</label>
								<input
									className="form-control form-control-lg"
									type="text"
									placeholder=""
									value={questions.additional}
									id="additional"
									onChange={this.changeValue}/>
							</fieldset>
						</div>
					</div>

					<p>An application fee of <b>$100</b> is  for the cost of processing this application, to obtain credit history and other background information.
					An application fee of <b>$50</b> will also be collected for each additional adult. (Applicant will pay after preapproval).</p>
					<p>Applicant represents that all information given on this application is true and correct. Applicant hereby authorizes verification of all references
					and facts, including but not limited to current and previous landlords and employers, and personal references. Applicant hereby authorizes owner/agent 
					to obtain Unlawful Detainer, Credit Reports, Telechecks, and/or criminal background reports. Applicant understands that incomplete or incorrect information
					provided in the application may cause a delay in processing which ,ay result in denial of tenancy. Applicant hereby waives any claim and releases from liability
					any person providing or obtaining said verification or additional information.</p>



	                 <fieldset className="form-group">

	                 <div className="radio">
				      <label>
				        <input type="radio" 
				        value={ruleAgreement}
				        onChange={this.changeRulesAgreement}
				        disabled={!this.props.ruleCLick}/>
				        I have read and I accept the <a target="_blank" onClick={this.handleRuleCLick} href={rules}>Rules and Regulations</a>
				      </label>
				    </div>
	                </fieldset>

	            {
	            	ruleAgreement != "on" &&
	            	<div className="alert alert-danger" role="alert">
					  <strong>You need to click on the link above to proceed!</strong>
					</div>
	            }

				{
					ruleAgreement == "on" &&
					<div>

	                <fieldset>
	                	<p> I, the applicant for this property application, warrant the truthfulness of the information provided in this application.</p>
	                	<div className="row">
	                	<div className="col-xs-4">
	                	<fieldset className="form-group">
						<label>Electronic Signature:  </label>
	                	<input type="text" 
	                		className="form-control form-control-sm"
		                	required
		                	placeholder="Legal First and Last Name"
		                	value={signature.signature}
							id="signature"
							onChange={this.changeValue}/>
						</fieldset>
						</div>
						</div>
	                	<label>
		                	<input required id="checkBox" type="checkbox"/> 
		                	I understand that checking this box constitutes a legal signature confirming that I acknowledge and agree to the above Terms of Acceptance.
		                </label>
	                
	                </fieldset>
	                <br/>
	                <div className="row">
		                <div className="col-xs-3">
						<button
							className="btn btn-lg btn-primary btn-block button pull-xs-right"
							type="submit">
							Submit
						</button>
						</div>
		                <div className="col-xs-9"></div>	
	                </div>
	                <br/>
					</div>
				}

				</div>
			}


	              </form>
			</div>
		);
	}
}


export default connect(mapSateToProps, mapDispatchToProps)(Application);



// WEBPACK FOOTER //
// ./src/components/Application.js